<template>
  <form class="form-vertical authentication-email" @submit.prevent="loginByEmail">
    <div v-for="input in authData.authInputs">
      <DefEmail
        v-if="input.type !== 'hidden' && input.type === 'text'"
        :required="input.type !== 'hidden'"
        :placeholder="messages.email"
        :name="input.name"
        :type="input.type"
        :value="emailValue ? emailValue : input.value"
        :error="input.error"
        @input="getTargetValue"
      />
      <DefInput
        v-else-if="input.type !== 'hidden'"
        :required="input.type !== 'hidden'"
        :placeholder="input.placeholder"
        :name="input.name"
        type="password"
        :value="input.value"
        :error="input.error"
      />
      <input v-else type="hidden" :name="input.name" :value="input.value" />
    </div>

    <EnterCabinetMainBtn :btn-values="messages.sign_in" />
  </form>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import DefEmail from '@components/Def/DefEmail/DefEmail.vue';
import DefInput from '@components/Def/DefInput/DefInput.vue';
import EnterCabinetMainBtn from '@components/Cabinet/EnterCabinet/EnterCabinetMainBtn.vue';

export default {
  name: 'AuthenticationEmail',
  components: { EnterCabinetMainBtn, DefInput, DefEmail },
  data() {
    return {
      emailValue: '',
    };
  },
  computed: {
    ...mapState({
      authData: ({ personal }) => personal.data,
      messages: ({ personal }) => personal.data.messages,
      btnValues: ({ personal }) => personal.data.btnValues,
      errors: ({ personal }) => personal.data.errors,
    }),
  },
  methods: {
    getTargetValue(value) {
      if (value instanceof Event) {
        this.emailValue = value.target.value;
      } else {
        this.emailValue = value;
      }
    },
    async loginByEmail(e) {
      this.$store.dispatch('personal/loginByEmail', { e, component: this });
    },
  },
};
</script>

<style lang="scss" scoped>
.authentication-email {
  :deep(.def-input) {
    margin-bottom: 20px;
  }
}
</style>
